import { CommonPageWrapper, HeadingWrapper } from 'admin/components/wrappers';
import CustomBreadCrumb from 'app/components/CustomBreadCrumb';
import { PageMainLabel } from 'app/components/SHLabel';
import BackButton from 'app/components/BackButton';
import styled from 'styled-components';
import AdminCustomButton from 'app/components/AdminCustomButton';
import SimpleReactValidator from 'simple-react-validator';
import React, { useEffect, useRef, useState } from 'react';
import { UserInfoFormBlock } from './UserInfoForm';
import { GeneralLookup, User } from 'services/openapi';
import useUserApi from 'admin/hooks/useUserApi';
import { useParams } from 'react-router-dom';
import { DropDownModel } from 'app/components/SHdropdown';
import { CommonLoader } from 'app/components/CommonLoader';
import { getLookupArray, useNavigateToRoute } from 'utils/common';
import {
  breadCrumpitemsUser,
  userDefaultData,
  userTypeCustomData,
} from '../../staticDefaultData';
import useCommonLookUpDatas from 'hooks/useCommonLookupData';
import PermissionsAccordion from '../../PermissionsAccordion';
import { usePermissionsApi } from 'hooks/usePermissionsApi';
import { TableSkeletonLoader } from 'app/components/TableSkeletonLoader';
import useRolePermissionApi from 'admin/pages/SettingsPage/SettingsCard/Components/SettingsPages/Roles/useRolePermissionApi';
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';
import { useErrorHandlingSlice } from 'app/error/slice';
import { isEqual } from 'lodash';

export const UserCreateEditPage = () => {
  const redirect = useNavigateToRoute();
  const simpleValidator = useRef(new SimpleReactValidator());
  const { action, id: userId } = useParams();
  const loggedInUserId = Cookies.get('userId');
  const {
    rolePermissionsList,
    getRolePermissionsList,
    setRolePermissionsList,
    getUserPermissionsList,
    loading: rolePermissionsLoading,
  } = usePermissionsApi();
  const {
    createUser,
    setImageUploadBlobPayload,
    imageUploadBlobPayload,
    EditUser,
    userViewData,
    getUserProfileViewData,
    loading,
    userViewLoading,
  } = useUserApi();
  const { fetchPermissionRoleList, permissionRoleData } =
    useRolePermissionApi();
  const [userTypeValue, setUserTypeValue] = React.useState<GeneralLookup>();

  const [roleValue, setRoleValue] = React.useState<GeneralLookup>();
  const [userPayload, setUserPayload] = useState<User>(userDefaultData);
  const [userPayloadDefault, setUserPayloadDefault] =
    useState<User>(userDefaultData);
  const [teamDefault, setTeamDefault] = useState<GeneralLookup>();
  const [teamDefaultSaved, setTeamDefaultSaved] = useState<GeneralLookup>();
  const [imgSrc, setImgSrc] = useState<string | null>(null);
  const [triggor, setTriggor] = useState(false);
  const [triggorTwo, setTriggorTwo] = useState(false);
  const [userPreDataList, setUserPreDataList] = useState<DropDownModel[]>([]);
  const [, setForceUpdate] = useState(false);
  const {
    getAllLookupData,
    lookUps,
    loading: lookUpLoading,
    getUserTypeLookupData,
    userTypeLookUps,
  } = useCommonLookUpDatas();
  const userTypeEditData = userViewData?.userTypes?.split(',');
  const filteredUserTypeCustomData =
    userTypeEditData?.length === 0
      ? []
      : userTypeCustomData?.filter(item => {
        const trimmedText = item.text.replace(/\s+/g, '');
        return userTypeEditData?.some(
          editItem => editItem.replace(/\s+/g, '') === trimmedText,
        );
      });
  const dispatch = useDispatch();
  const { actions } = useErrorHandlingSlice();
  const handleSaveClick = () => {
    const showMessagesForFields = (fields: string[]) => {
      let messagesShown = false;
      const invalidFields: string[] = [];

      fields.forEach(field => {
        simpleValidator.current.showMessageFor(field);
        if (!simpleValidator.current.fieldValid(field)) {
          messagesShown = true;
          invalidFields.push(field);
        }
      });

      setForceUpdate(prev => !prev);
      return { messagesShown, invalidFields };
    };

    const commonFields = [
      'Address',
      'City',
      'Phone Number',
      'State',
      'User Email',
      'User First Name',
      'User Last Name',
      'User Name',
      'User Type',
      'Zip',
      'Role',
      'Team',
    ];

    const { userGroupType } = userPayload;

    // Filter out the field we *don't* want to show based on userGroupType
    let fieldsToValidate = [...commonFields];

    if (userGroupType === 1) {
      // Admin: remove "Team"
      fieldsToValidate = fieldsToValidate.filter(field => field !== 'Team');
    } else if (userGroupType === 3) {
      // Team User: remove "Role"
      fieldsToValidate = fieldsToValidate.filter(field => field !== 'Role');
    }

    const { messagesShown, invalidFields } =
      showMessagesForFields(fieldsToValidate);
    if (!messagesShown) {
      const isCreating = action === 'create';
      const isUpdating = action === 'update';
      const isUnchanged =
        isEqual(userPayloadDefault, userPayload) &&
        imageUploadBlobPayload === null;

      const payload = {
        ...userPayload,
        permissions: {
          userId: isCreating ? null : userPayload.id,
          modules: rolePermissionsList,
        },
      };

      if (isCreating) {
        createUser(payload, imageUploadBlobPayload ?? undefined);
      } else if (isUpdating) {
        if (isUnchanged) {
          dispatch(
            actions.dispatchToast({
              errorTxt: 'No changes have been made',
              show: true,
              errorType: 'error',
            }),
          );
        } else {
          EditUser(payload, imageUploadBlobPayload ?? undefined);
        }
      }
    } else {
      simpleValidator.current.showMessages(); // Show any remaining messages
    }

    setTriggor(prev => !prev);
  };
  const handleCancelClick = () => {
    if (action === 'create') {
      setUserPayload(userDefaultData);
      setImgSrc(null);
      setImageUploadBlobPayload(null);
      setTeamDefault(undefined);
      setUserPreDataList([]);
      setRoleValue(undefined);
    } else if (action === 'update' && userId) {
      setImageUploadBlobPayload(null);
      setUserPreDataList(filteredUserTypeCustomData);
      setImgSrc(userViewData?.photo!);
      setUserPayload(userPayloadDefault);
      setTeamDefault(teamDefaultSaved);
      const updateRoleData = permissionRoleData.find(
        item => item.normalizedName === userViewData?.userTypes,
      );
      setRoleValue({
        id: updateRoleData?.roleId as string,
        name: updateRoleData?.normalizedName as string,
      });
    }
    setTriggorTwo(!triggorTwo);
    simpleValidator.current.hideMessages();
    simpleValidator.current.visibleFields = [];
  };

  const handleBackClick = () => {
    if (action === 'update') {
      redirect(`/admin/users/view/${userId}`);
    } else {
      redirect(`/admin/users`);
    }
  };

  React.useEffect(() => {
    if (action === 'update') {
      getUserProfileViewData(userId ?? '');
      // getUserPermissionsList(loggedInUserId ?? '');
    }
    fetchPermissionRoleList();
    getUserTypeLookupData();
  }, [userId, action]);
  React.useEffect(() => {
    getAllLookupData('STATE,SEASON,ACTIVESTATUS,PROFESSIONALAFFILIATIONS,TEAM');
  }, []);
  React.useEffect(() => {
    const isTeamUser = filteredUserTypeCustomData.some(item => {
      return item.text.toLowerCase() === 'team user';
    });
    if (userViewData && lookUps) {
      const teamList = getLookupArray('TEAM', lookUps);
      const teamSelected = teamList?.find(
        obj => obj.id === userViewData?.team?.id,
      );
      if (isTeamUser) {
        setTeamDefault(teamSelected);
        setTeamDefaultSaved(teamSelected);
      }
    }
  }, [lookUps]);
  useEffect(() => {
    if (roleValue?.id && action === 'create') {
      getRolePermissionsList(roleValue?.id);
    } else if (action === 'update' && roleValue?.id) {
      getRolePermissionsList(roleValue?.id, true, userViewData?.userId ?? '');
    } else {
      getRolePermissionsList();
    }
  }, [roleValue?.id, userViewData?.userId]);
  React.useEffect(() => {
    if (action === 'update' && userId && userViewData) {
      const { userTypes, team, ...rest } = userViewData;
      setUserPayload({
        ...rest,
        userType: userTypes,
        teamId: team?.id,
        permissions: {
          userId: userViewData.id,
          modules: rolePermissionsList,
        },
      });

      const updateRoleData = permissionRoleData.find(
        item => item.normalizedName === userViewData.userTypes,
      );
      setRoleValue({
        id: updateRoleData?.roleId as string,
        name: updateRoleData?.normalizedName as string,
      });
      setUserPayloadDefault({
        ...userViewData,
        userType: userViewData?.userTypes,
        permissions: {
          userId: userViewData.id,
          modules: rolePermissionsList,
        },
      });
      setUserPreDataList(filteredUserTypeCustomData);
      setImgSrc(userViewData.photo ?? '');
      if (userViewData.userTypes !== 'TEAMUSER') {
        getRolePermissionsList(
          updateRoleData?.roleId,
          true,
          userViewData?.userId ?? '',
        );
        setUserTypeValue({
          id: '1',
          name: 'ADMIN',
        });
      } else {
        const foundUserType = userTypeLookUps.find(item => item.id === 3);
        const defaultRole = foundUserType?.children?.[0] || {
          id: '',
          name: '',
        };
        getRolePermissionsList(defaultRole?.id);
        setUserTypeValue({
          id: '3',
          name: 'TEAMUSER',
        });
      }
    }
  }, [userViewData, userId, permissionRoleData]);
  return (
    <>
      <CommonPageWrapper>
        {loading && <CommonLoader loaderType="main" />}
        <HeadingWrapper>
          <PageMainLabel>User Information</PageMainLabel>
          <CustomBreadCrumb preData={breadCrumpitemsUser} />
        </HeadingWrapper>
        <ContentWrapper>
          <BtnWrapper>
            <div>
              <BackButton onClick={handleBackClick} />
            </div>
            <div className="btn-action">
              <AdminCustomButton
                buttonType="cancel"
                onClick={handleCancelClick}
              >
                Clear
              </AdminCustomButton>
              <AdminCustomButton buttonType="save" onClick={handleSaveClick}>
                Save
              </AdminCustomButton>
            </div>
          </BtnWrapper>
          <UserInfoFormBlock
            simpleValidator={simpleValidator}
            setUserPayload={setUserPayload}
            userPayload={userPayload}
            setImageUploadBlobPayload={setImageUploadBlobPayload}
            setTeamDefault={setTeamDefault}
            teamDefault={teamDefault}
            setImgSrc={setImgSrc}
            imgSrc={imgSrc}
            setUserPreDataList={setUserPreDataList}
            userPreDataList={userPreDataList}
            loading={userViewLoading || lookUpLoading}
            lookUps={lookUps}
            permissionRoleData={permissionRoleData}
            setRoleValue={setRoleValue}
            roleValue={roleValue}
            userTypeLookUps={userTypeLookUps}
            getRolePermissionsList={getRolePermissionsList}
            setUserTypeValue={setUserTypeValue}
            userTypeValue={userTypeValue}
          />
          <div>
            {rolePermissionsLoading ? (
              <TableSkeletonLoader
                rowContent={8}
                width={100}
                headingWidth={80}
              />
            ) : (
              <>
                {userTypeValue?.id === '1' && (
                  <PermissionsAccordion
                    rolePermissionsList={rolePermissionsList ?? []}
                    setRolePermissionsList={setRolePermissionsList}
                  />
                )}
              </>
            )}
          </div>
        </ContentWrapper>
      </CommonPageWrapper>
    </>
  );
};
const ContentWrapper = styled.div`
  width: 100%;
  padding: 15px 30px 15px 0;
`;
const BtnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding: 15px 5px;
  border-bottom: 1px solid #eaecf0;
  .btn-action {
    display: flex;
    align-items: center;
    gap: 15px;
  }
`;
